import {Component, OnInit} from "@angular/core";
import {UserService} from "../../services/users.service";
import {ActivatedRoute, Router} from "@angular/router";
import {Auth2Service} from "../../../../services/auth2.service";
import {HttpErrorResponse} from "@angular/common/http";
import {PaymentCardDto} from "../../../../models/payment-card-dto";
import {LoggedInPageBaseComponent} from "../../../../shared-components/ui-components/logged-in-page-base/logged-in-page-base.component";
import {Title} from "@angular/platform-browser";

@Component({
  selector: 'app-successful-consultant-checkout',
  templateUrl: './successful-consultant-checkout.component.html',
  styleUrls: ['./successful-consultant-checkout.component.scss'],
  standalone: false
})
export class SuccessfulConsultantCheckoutComponent implements OnInit {
  breadCrumbs = [
    { iconClass: 'bi-house', path: 'app/users/dashboard'},
    { label: 'Successful Consultant Checkout'}
  ];

  showMessages = false;
  messages: any[] = [];
  pageSuccessMessages: any[] = [];
  pageErrorMessages: any[] = [];
  showPageSuccessMessages: boolean = false;
  showPageErrorMessages: boolean = false;
  username: string = '';

  pageName = 'Successful Consultant Checkout';

  constructor(private userService: UserService,
              private routerChild: Router,
              private auth2ServiceChild: Auth2Service,
              private titleService: Title) {
    this.titleService.setTitle("Scalanthropy Successful Consultant Checkout");
  }

  showPageSuccessMessagesToUser(delayMs: number = 60000): void {
    this.showPageSuccessMessages = true;
    const counterFn = () => {
      this.showPageSuccessMessages = false;
    }
    setTimeout(counterFn, delayMs);
  }

  showPageErrorMessagesToUser(delayMs: number = 60000): void {
    this.showPageErrorMessages = true;
    const counterFn = () => {
      this.showPageErrorMessages = false;
    }
    setTimeout(counterFn, delayMs);
  }

  ngOnInit() {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    this.username = this.auth2ServiceChild.getUsername();
    localStorage.removeItem('username');
    this.userService.setUserDefaultPayment(this.username).subscribe(
      (result: any) => {
        if (result && result.body) {
          this.pageSuccessMessages.push({
            field: 'Consultant Referral Code Error',
            detail: 'Consultant Referral Code failed to verify.',
            severity: 'error'
          });
          this.showPageSuccessMessagesToUser();
        }
      },(error: HttpErrorResponse) => {
        this.pageErrorMessages.push({
          field: 'Consultant Referral Code Error',
          detail: 'Consultant Referral Code failed to verify.',
          severity: 'error'
        });
        this.showPageErrorMessagesToUser();
      }
    );
    const counterFn = () => {
      this.routerChild.navigateByUrl('app/login');
    }
    setTimeout(counterFn, 10000);
  }

  onGoToLogin(): void {
    this.routerChild.navigateByUrl('app/login');
  }
}
